import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonCol, IonIcon, IonRow } from "@ionic/vue";
import { isDev, isNotLive } from "@/functions/enviroment";

export default /*@__PURE__*/_defineComponent({
  __name: 'LogoRow',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonRow), { style: {"min-height":"calc(6rem + 80px)"} }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCol), {
        class: _normalizeClass(["center flex-d-c ion-no-padding p-5", { 'rot-180': _unref(isNotLive)() }])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            icon: "assets/icon/logo.svg",
            class: _normalizeClass(["octo-logo coral-light-color", { 'coral-logo': _unref(isDev)() }])
          }, null, 8, ["class"]),
          _createVNode(_unref(IonIcon), {
            icon: "assets/icon/logoTitle.svg",
            class: "octo-title mt-1 coral-light-color"
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}
}

})